// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3T3SB","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1lzIr"};